import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();
  return (
    <footer className="bg-navy border-t border-accent/10">
      <div className="max-w-6xl mx-auto px-6 sm:px-8 lg:px-12 py-16">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="flex flex-col items-center gap-6"
        >
          {/* Copyright */}
          <div className="text-slate text-sm font-mono text-center">
            <p>{t('footer.designedBy')}</p>
            <p className="mt-2">
              {t('footer.copyright', { year: new Date().getFullYear() })}
            </p>
          </div>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;
